export const WELCOME_MESSAGE = 'WELCOME_MESSAGE';
export const CHAT_THREAD = 'CHAT_THREAD';
export const SPOTLIGHT = 'SPOTLIGHT';